import { render, staticRenderFns } from "./SettingLicense.vue?vue&type=template&id=b272a1ba&scoped=true&"
import script from "./SettingLicense.vue?vue&type=script&lang=js&"
export * from "./SettingLicense.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/setting.css?vue&type=style&index=0&id=b272a1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b272a1ba",
  null
  
)

export default component.exports